export default __webpack_public_path__ + "static/media/movii.f80701bb.svg";